import { AccessTypeConstants, DASH_IMG_COORDINATOR, DASH_IMG_DEALER, DASH_IMG_FARMER, DASH_IMG_SP, MILK_CANS_IMG, MONEY_COORDINATOR_IMG, RUPEE_IMG } from '@/_constant';
import { useLanguageContext } from '@/hooks';
import React from 'react';

const HowToSell = ({ selectedData }) => {
    const { language } = useLanguageContext();
    const howtoSellText = {
        [AccessTypeConstants.AGENT]: DASH_IMG_COORDINATOR,
        [AccessTypeConstants.FARMER]: "label.how_to_sell_as_farmer",
        [AccessTypeConstants.OTHERS]: "label.how_to_sell_as_farmer",
        [AccessTypeConstants.DEALER]: "label.how_to_sell_as_dealer",
        [AccessTypeConstants.SERVICE_PROVIDER]: "label.how_to_give_machinery_service",
        "harvesting": "label.how_to_give_harvester_service",
        "borewell": "label.how_to_give_borewell_service",
        "horse-breeding":"label.how_to_give_breeding_service",
        "live-stock-breeding":"label.how_to_give_breeding_service",
        "dairy-center":"label.how_to_collect_milk",
        "milk-plant":"label.how_to_collect_milk",
        "spray":"label.how_to_give_harvester_service",
        "ambulance":"label.how_to_give_ambulance_service",
        "agent":"label.how_to_earn_as_coordinator",
        "assignee":"label.how_it_works_for_assignee"

    }
    
    const getMeta = () => {
        
        if (selectedData.category_id === '999') {
            return howtoSellText[selectedData?.category_name?.toLowerCase().replaceAll(" ", "-")]
        }

        if (selectedData.category_id === '234') {
            return howtoSellText[selectedData?.category_name?.toLowerCase().replaceAll(" ", "-")]
        }
        if (selectedData.category_id === '245') {
            return howtoSellText[selectedData?.category_name?.toLowerCase().replaceAll(" ", "-")]
        }
        if (selectedData.category_id === '267') {
            return howtoSellText[selectedData?.category_name?.toLowerCase().replaceAll(" ", "-")]
        }
        if (selectedData.category_id === '271') {
            return howtoSellText[selectedData?.category_name?.toLowerCase().replaceAll(" ", "-")]
        }
        
        
        if (selectedData.category_id === '240' || selectedData.category_id === '206') {
            return howtoSellText[selectedData?.category_name?.toLowerCase().replaceAll(" ", "-")]
        }
        if (selectedData.category_id === '168' || selectedData.category_id === '169') {
            return howtoSellText[selectedData?.category_name?.toLowerCase().replaceAll(" ", "-")]
        }
        return howtoSellText[selectedData?.access_name?.toLowerCase().replaceAll(" ", "-")]
    }

    return (
        <>
        <h5 className='mb-2 text-dark'>
            {language(getMeta())}   
          <br />
        </h5>
        </>
    );
};

export default HowToSell;